'use client'
import { GetFeaturedSessions, MatchDetail } from '@/app/libs/match/types'
import MyImage from '@/shared/components/myImage'
import ThemeTable from '@/shared/components/themeTable'
import { RightArrow } from '@/shared/Icons'
import { getImgURL, getInningsSuffix } from '@/shared/utils'
import { useState } from 'react'

export default function SessionTable({
  sessionData,
  matchDetail
}: {
  sessionData?: GetFeaturedSessions[]
  matchDetail: MatchDetail
}) {
  const [activeIndex, setActiveIndex] = useState<number>(0)

  const sessionLabels = ['Session', 'Min', 'Max', 'Open', '', 'Pass']
  return (
    <>
      <p className="text-lg font-bold text-textOffWhite mb-3">Session Table</p>
      {sessionData?.map((session, index: number) => {
        const teamData = matchDetail.aInning.find(
          inning => inning?.nInningNumber === session?.nInningNumber
        )
        return (
          <div key={session?.nInningNumber}>
            <button
              className="flex items-center gap-2 justify-between text-lg font-medium w-full mb-4"
              onClick={() => setActiveIndex(prev => (prev === index ? -1 : index))}
            >
              <span className="text-TextOffPlayer flex items-center gap-3">
                {teamData?.oBattingTeam?.oImg?.sUrl ? (
                  <MyImage
                    src={getImgURL(teamData?.oBattingTeam?.oImg?.sUrl)}
                    className="w-7 h-7 rounded-full object-cover"
                    height={28}
                    width={28}
                    alt={teamData?.oBattingTeam?.oImg?.sText}
                  />
                ) : null}
                {teamData?.sShortName ? (
                  <>{teamData?.sShortName} Inn</>
                ) : (
                  <>{getInningsSuffix(session?.nInningNumber)} Inning</>
                )}
              </span>
              <span
                className={`block h-4 w-4 transition-transform text-subSectionText ${activeIndex === index ? '-rotate-90' : 'rotate-90'}`}
              >
                <RightArrow />
              </span>
            </button>

            {activeIndex === index ? (
              <ThemeTable
                key={session?.nInningNumber}
                labels={sessionLabels}
                className="!rounded-none md:!rounded-xl"
                isBordered
              >
                {session?.aSessions?.map(data => {
                  return (
                    <>
                      <tr key={index}>
                        <td className="!w-full" width={90}>
                          <span className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                            <span className="flex items-center">{data?.sOver} Overs</span>
                          </span>
                        </td>
                        <td className="">{data?.sMin}</td>
                        <td className="">{data?.sMax}</td>
                        <td className="">{data?.sOpen}</td>
                        <td
                          className={
                            data?.sOpen > data?.sPass ? '!text-[#FF7575]' : '!text-[#6CB240]'
                          }
                        >
                          {data?.sOpen === data?.sPass
                            ? '='
                            : data?.sOpen > data?.sPass
                              ? '>'
                              : '<'}
                        </td>
                        <td
                          className={
                            data?.sPass
                              ? data?.sOpen > data?.sPass
                                ? '!text-[#FF7575]'
                                : '!text-[#6CB240]'
                              : 'text-textDselected'
                          }
                        >
                          {data?.sPass || '- -'}
                        </td>
                      </tr>
                    </>
                  )
                })}
              </ThemeTable>
            ) : null}
          </div>
        )
      })}
    </>
  )
}
